import { Link } from "react-router-dom";
import Button from "../components/Shared/Button/Button";
import { Input } from "../components/Shared/Input/AuthInput";

const Login = () => {
  return (
    <div className="grid min-h-screen place-items-center bg-lightGray">
      <div className="flex w-[716px] flex-col items-center justify-center rounded-[20px] bg-white">
        <picture className="mt-14 mb-8 h-28 w-52">
          <img src="/assets/images/logo.png" alt="" />
        </picture>
        <p className="mb-14 font-inter text-[32px] font-semibold text-black text-opacity-50">
          Sign in
        </p>
        <div className="w-full px-32">
          <Input placeholder="Email/User name" />
          <Input placeholder="Password" password />
          <Link to="/reset-password" className="mt-3 mb-9 block">
            <p className="text-right font-pop text-sm text-black text-opacity-50">
              Forget Password
            </p>
          </Link>
          <Button
            text="Sign In"
            variant="primary"
            className="mb-14 !w-full rounded-lg !py-3"
          />
        </div>
      </div>
    </div>
  );
};

export default Login;
